module.exports = __webpack_public_path__ + "static/media/logo-dark.09e15212.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/logo-dark.svg
// module id = 596
// module chunks = 0